import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Select,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useRecoilState, useSetRecoilState } from "recoil";
import * as yup from "yup";
import useAxios from "axios-hooks";

import { toastState } from "atoms/toastState";
import { updateChargingPointDrawerState } from "atoms/updateChargingPointDrawerState";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";
import { chargePointDrawerSelectOptions } from "../variables/chargePointDrawerSelectOption";

const UpdateChargePointDrawer = (props) => {
  const setToast = useSetRecoilState(toastState);
  const [drawerState, setDrawerState] = useRecoilState(
    updateChargingPointDrawerState,
  );
  const [chargePoint, setChargePoint] = useState({
    Name: "",
    StationId: "",
    // Description: "",
    Visibility: "",
    TypeOfCharger: "",
    Power: "",
  });

  const validationSchema = yup.object().shape({
    Name: yup.string(),
    StationId: yup.string(),
    // Description: yup.string(),
    Visibility: yup.string(),
    PowerType: yup.string(),
    MaxElectricPower: yup.string(),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const [{ loading: chargePointLoading }, getChargePoint, cancelRequest] =
    useAxios(
      { method: "GET", url: `/api/stations/${props?.chargePointId}` },
      { manual: true },
    );

  const [
    { data: UpdateChargePoint, loading: updateChargingPointLoading },
    updateChargePoint,
  ] = useAxios(
    {
      method: "PATCH",
      url: `/api/stations/update/${props?.chargePointId}`,
    },
    { manual: true },
  );

  const getChargePointDetails = async () => {
    try {
      const response = await getChargePoint();
      const data = response.data.data;
      setValue("Name", data.Name);
      setValue("StationId", data.StationId);
      setValue("Visibility", data.Visibility);
      setValue("PowerType", data.PowerType);
      setValue("MaxElectricPower", data.MaxElectricPower);
      // setValue("Description", data.Description);

      setChargePoint((prev) => {
        return {
          ...prev,
          Name: data.Name,
          StationId: data.StationId,
          Description: data?.Description,
          Visibility: data?.Visibility,
          PowerType: data.PowerType,
          MaxElectricPower: data.Power,
        };
      });
    } catch (error) {
      logger.log(error?.code);
      if (error?.code !== "ERR_CANCELED") {
        setToast({
          isOpen: true,
          title: "Error occured while getting ChargePoint details",
          status: "error",
        });
        closeHandler();
      }
    }
  };

  const closeHandler = () => {
    setDrawerState(null);
  };

  const UpdateHandler = async () => {
    const formValues = getValues();
    let chargePointUpdate = {};
    if (
      formValues.Name.trim() !== "" &&
      formValues.Name.trim() !== chargePoint.Name
    ) {
      chargePointUpdate["Name"] = formValues.Name.trim();
    }
    if (
      formValues.StationId.trim() !== "" &&
      formValues.StationId.trim() !== chargePoint.StationId
    ) {
      chargePointUpdate["StationId"] = formValues.StationId.trim();
    }
    if (
      formValues.PowerType.trim() !== "" &&
      formValues.PowerType.trim() !== chargePoint.PowerType
    ) {
      chargePointUpdate["PowerType"] = formValues.PowerType.trim();
    }
    if (
      typeof formValues.MaxElectricPower === "string" &&
      formValues.MaxElectricPower.trim() !== ""
    ) {
      chargePointUpdate["MaxElectricPower"] = parseInt(
        formValues.MaxElectricPower.trim(),
      );
    }
    if (
      formValues.Visibility.trim() !== "" &&
      formValues.Visibility.trim() !== chargePoint.Visibility
    ) {
      chargePointUpdate["Visibility"] = formValues.Visibility.trim();
    }

    if (Object.keys(chargePointUpdate).length > 0) {
      try {
        const response = await updateChargePoint({ data: chargePointUpdate });
        setToast({
          isOpen: true,
          title: "ChargePoint details Updated",
          status: "success",
        });
        props.update();
      } catch (error) {
        const err = error?.response?.data?.error;
        logger.log(error);
        setToast({
          isOpen: true,
          title: "Error occured when updating Charge Point",
          description: err ? err : null,
          status: "error",
        });
      }
    } else {
      setToast({
        isOpen: true,
        title: "nothing new to update",
        status: "warning",
      });
    }
  };

  useEffect(() => {
    if (props?.chargePointId) {
      getChargePointDetails();
      return () => cancelRequest();
    }
  }, []);

  return (
    <Drawer
      isOpen={drawerState?.isOpen}
      placement="right"
      onClose={closeHandler}
      size="md"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Update Charger Details</DrawerHeader>
        <DrawerBody>
          {!chargePointLoading && !updateChargingPointLoading ? (
            <>
              <Card>
                <form>
                  {chargePointDrawerSelectOptions.map((item, index) => (
                    <Flex key={index} mb="20px" alignItems="center">
                      <Controller
                        name={item.name}
                        control={control}
                        render={({ field }) => (
                          <FormControl
                            isRequired
                            flexDirection="row"
                            isInvalid={errors[item.name]}
                          >
                            <FormLabel fontSize={16}>{item.label}</FormLabel>
                            {item.type === "select" ? (
                              <Select
                                {...field}
                                focusBorderColor="#f57d36"
                                fontSize="sm"
                                width={{ base: "100%", md: "400px" }}
                                height="50px"
                              >
                                <option value="">SELECT</option>
                                {item.options.map((option, ind) => (
                                  <option key={ind} value={option.value}>
                                    {option.name}
                                  </option>
                                ))}
                              </Select>
                            ) : (
                              <Input
                                {...field}
                                focusBorderColor="#f57d36"
                                fontSize="sm"
                                placeholder={item.placeholder}
                                width={{ base: "100%", md: "400px" }}
                                height="50px"
                                type={item.type}
                                isRequired
                              />
                            )}
                            <FormHelperText color={"#f57d36"}>
                              {item.helper}
                            </FormHelperText>
                            <FormErrorMessage mb={"20px"}>
                              {errors[item.name] && errors[item.name].message}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      />
                    </Flex>
                  ))}
                </form>
              </Card>
            </>
          ) : (
            <LoadingSpinner />
          )}
        </DrawerBody>
        <DrawerFooter flexWrap="wrap" gap={2}>
          <Button
            variant="outline"
            onClick={closeHandler}
            flex={{ base: "1", md: "0" }}
            minW={{ base: "auto", md: "100px" }}
          >
            Cancel
          </Button>
          <Button
            bg="#f57d36"
            color="white"
            colorScheme="orange"
            onClick={handleSubmit(UpdateHandler)}
            isLoading={updateChargingPointLoading}
            flex={{ base: "1", md: "0" }}
            minW={{ base: "auto", md: "100px" }}
          >
            Update
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default UpdateChargePointDrawer;
